var _circle, _rect, _path, _path2, _path3, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame1Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#5F3FC0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.2441,
    y: 40.0002,
    width: 4.88293,
    height: 20,
    fill: "#5F3FC0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2441 39.9999C30.2441 38.0704 30.8163 36.1841 31.8883 34.5797C32.9604 32.9754 34.484 31.7249 36.2667 30.9865C38.0494 30.2481 40.0111 30.0549 41.9036 30.4313C43.7961 30.8077 45.5344 31.7369 46.8988 33.1013C48.2633 34.4657 49.1924 36.2041 49.5689 38.0966C49.9453 39.9891 49.7521 41.9507 49.0137 43.7334C48.2753 45.5161 47.0248 47.0398 45.4204 48.1118C43.8161 49.1838 41.9298 49.756 40.0002 49.756L40.0002 44.8731C40.9641 44.8731 41.9062 44.5873 42.7076 44.0518C43.509 43.5164 44.1336 42.7553 44.5025 41.8648C44.8713 40.9744 44.9678 39.9945 44.7798 39.0492C44.5918 38.1039 44.1276 37.2356 43.4461 36.5541C42.7646 35.8725 41.8963 35.4084 40.951 35.2204C40.0056 35.0323 39.0258 35.1289 38.1354 35.4977C37.2449 35.8665 36.4838 36.4911 35.9483 37.2925C35.4129 38.0939 35.1271 39.0361 35.1271 39.9999L30.2441 39.9999Z",
    fill: "#5F3FC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 60.0002C45.3043 60.0002 50.3914 57.8931 54.1421 54.1423C57.8929 50.3916 60 45.3045 60 40.0002C60 34.6959 57.8929 29.6088 54.1421 25.8581C50.3914 22.1074 45.3043 20.0002 40 20.0002V25.092C43.9539 25.092 47.7459 26.6627 50.5417 29.4585C53.3375 32.2543 54.9082 36.0463 54.9082 40.0002C54.9082 43.9541 53.3375 47.7461 50.5417 50.5419C47.7459 53.3378 43.9539 54.9084 40 54.9084V60.0002Z",
    fill: "#5F3FC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40C60 34.6957 57.8929 29.6086 54.1421 25.8579C50.3914 22.1071 45.3043 20 40 20C34.6957 20 29.6086 22.1071 25.8579 25.8579C22.1071 29.6086 20 34.6957 20 40L25.0918 40C25.0918 36.0461 26.6625 32.2541 29.4583 29.4583C32.2541 26.6625 36.0461 25.0918 40 25.0918C43.9539 25.0918 47.7459 26.6625 50.5417 29.4583C53.3375 32.2541 54.9082 36.0461 54.9082 40L60 40Z",
    fill: "#5F3FC0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.561,
    cy: 47.1952,
    r: 2.56098,
    fill: "#5F3FC0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1Icon);
export default __webpack_public_path__ + "static/media/frame-1-icon.f9622a639f4d30e132fcbcb3866ad7bc.svg";
export { ForwardRef as ReactComponent };